<template>
    <div class="wrapper__winner">
        <div class="wrapper__container">
            <div class="wrapper__winner__mask"></div>
        </div>
    </div>
</template>

<script>
  import CONFIG from '@/config';

  export default {

    name: 'Winner',

    mounted() {
        const script = document.createElement('script');
        script.setAttribute('src', 'lib/confetti.js');
        script.id = 'confetti-js';
        script.onload = () => {
            if (typeof window.confetti !== 'undefined') {
                window.confetti.start();
            }
        };
        document.body.appendChild(script);
    },

    beforeDestroy() {
        const script = document.getElementById('confetti-js');
        script.parentNode.removeChild(script);
    },

    data() {

      return {

      };
    }
  }
</script>

<style lang="scss">
    #confetti-canvas {
        z-index: 0 !important;
    }

    .wrapper__winner {
        background-image: url('/images/background.png');
        background-repeat: no-repeat;
        background-position: bottom;
        height: 100%;
        position: absolute;
        width: 100%;
        top: 0;
        left: 0;

        .wrapper__container {
            background-image: url('/images/winner_background.png');
            background-repeat: no-repeat;
            background-position: bottom;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }

        &__mask {
            background-image: url('/images/winner_mask.png');
            height: 228px;
            position: absolute;
            top: 244px;
            left: 50%;
            transform: translateX(-50%);
            width: 399px;
        }
    }
</style>
